export const removeElement = (list, element) => {
  return list.filter((item) => item !== element);
};

export const removeListFromList = (list, fixedList) => {
  const fixedListSet = new Set(fixedList);
  return list.filter((element) => !fixedListSet.has(element));
};
